import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { BillingInfoResourceModel } from '@/modules/billing-info/models/billing-info-resource'
import { PanelBillingInfoService } from '@/modules/billing-info/services/panel-billing-info.service'

@vservice()
export class PanelUpdateBillingInfoUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: PanelBillingInfoService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(data: BillingInfoResourceModel) {
    return this.service.updateBillingInfo(data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
